// import { Box, Button, Grid, Typography } from '@mui/material'
// import React, { useEffect } from 'react'
// import CustomDropdownMui from '../../../Components/CustomDropDown/CustomDropdown'
// import actions from '../../../ReduxStore/actions'
// import { useDispatch, useSelector } from 'react-redux'
// import { Formik, Form } from 'formik'
// import CustomRadioButton from '../../../Components/CustomRadioButton/CustomRadioButton'
// import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice'
// import { toast, ToastContainer } from 'react-toastify'
// import * as Yup from 'yup';

// const validationSchema = Yup.object().shape({
//     filterByYear: Yup.string().required('Year of Appraisal is required'),
//     pmsScore: Yup.boolean().required('PMS Score selection is required'),
// })

// const PmsScoreEnable = () => {
//     const dispatch = useDispatch()

//     const { getAllAppraisalYears } = useSelector((state) => state?.getAllAppraisalYears);
//     console.log(getAllAppraisalYears, "getAllAppraisalYears")

//     useEffect(() => {
//         const fetchData = async () => {

//             const data1 = {
//                 data: {},
//                 method: "get",
//                 apiName: "getAllAppraisalYears"
//             };
//             const responseData = dispatch(actions.GETALLAPPRAISALYEAR(data1));
//             console.log(responseData, "responseData")

//         }
//         fetchData()

//     }, [])

//     const yearOptions = getAllAppraisalYears?.data?.map((data, index) => ({

//         // id: data?.internship_id,
//         value: data?.appraisal_year_id,
//         label: data?.appraisal_year
//     }));
//     console.log(yearOptions, "yearOptions")

//     useEffect(() => {
//         dispatch(setHeaderName("Reports"));
//         dispatch(setSubHeaderName("PMS Score Enable"));
//     }, [dispatch]);

//     // const handleSubmit = async (values, { resetForm }) => {
//     //     console.log(values, "valuesssssss")

//     //     if (values?.file) {

//     //         const data1 = {
//     //             data: {
//     //                 appraisal_year_id: values?.filterByYear,
//     //                 pms_score_show: values?.pmsScore
//     //             },
//     //             method: "post",
//     //             apiName: "pmsScoreShowHide"
//     //         };
//     //         const responseData = await dispatch(actions.PMSSCORESHOWHIDE(data1));
//     //         if (responseData?.payload?.message === `pms_score_show set to '${values?.pmsScore}' for 1 records.`) {
//     //             if (values?.pmsScore) {
//     //                 toast.success("PMS score show enabled")
//     //             } else if (values?.pmsScore) {
//     //                 toast.success("PMS score show disabled")

//     //             } else {
//     //                 toast.error(responseData?.payload?.message)
//     //             }
//     //         }
//     //     }
//     // }
//     const handleSubmit = async (values, { resetForm }) => {
//         console.log(values, "valuesssssss");

//         const data1 = {
//             data: {
//                 appraisal_year_id: values?.filterByYear,
//                 pms_score_show: values?.pmsScore === "true" ? true : false
//             },
//             method: "put",
//             apiName: "pmsScoreShowHide"
//         };

//         const responseData = await dispatch(actions.PMSSCORESHOWHIDE(data1));
//         console.log(responseData,"responseData12212121")

//         if (responseData?.payload?.message === `pms score showing updated .`) {
//             if (values?.pmsScore==="true") {

//                 toast.success("PMS score show enabled");
//                 resetForm()

//             } else {
//                 toast.success("PMS score show disabled");
//                 resetForm()
//             }
//             // toast.success('kfofkorfkoprk')
//         } else {
//             toast.error(responseData?.payload?.message || "Something went wrong");
//         }
//     };

//     return (
//         <Box
//             sx={{
//                 background: "white",
//                 p: 3
//             }}
//         >
//             <Box
//             // sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
//             >
//                 <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px", mb: 2 }}>
//                     PMS Score Enable
//                 </Typography>
//                 <Formik
//                     initialValues=
//                     {{ filterByYear: "", pmsScore: "true" }}

//                     validationSchema={validationSchema}
//                     onSubmit={handleSubmit}
//                 >
//                     {({ isSubmitting, values, setFieldValue, resetForm, errors, touched, handleChange, handleBlur }) => (
//                         <Form>
//                             <Grid container spacing={4}>

//                                 <Grid item size={{ sm: 5, xs: 12 }}>
//                                     <CustomDropdownMui
//                                         name="filterByYear"
//                                         label=" Select Year of Appraisal"
//                                         custPlaceholder="--Select Year of Appraisal--"
//                                         // disabled
//                                         options={yearOptions}
//                                     />
//                                 </Grid>

//                                 <Grid item size={{ sm: 5, xs: 12 }}>
//                                     <CustomRadioButton
//                                         name="pmsScore"
//                                         label="PMS Score"
//                                         custPlaceholder="--Select--"
//                                         value={values?.pmsScore}
//                                         onChange={(val) => setFieldValue("pmsScore", val)}

//                                         options={[
//                                             { label: "Enabled", value: true },
//                                             { label: "Disabled", value: false },

//                                         ]}
//                                     />
//                                 </Grid>
//                                 <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
//                                     <Button
//                                         type="submit"
//                                         variant='contained'
//                                         sx={{
//                                             background: "var(--main-color)",
//                                             textTransform: "none"
//                                         }}
//                                     >
//                                         Submit
//                                     </Button>
//                                 </Grid>

//                             </Grid>
//                         </Form>
//                     )}
//                 </Formik>

//             </Box>
//             <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />

//         </Box>
//     )
// }

// export default PmsScoreEnable

import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomDropdownMui from "../../../Components/CustomDropDown/CustomDropdown";
import actions from "../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import CustomRadioButton from "../../../Components/CustomRadioButton/CustomRadioButton";
import {
  setHeaderName,
  setSubHeaderName,
} from "../../../ReduxStore/Slices/headerSlice";
import { toast, ToastContainer } from "react-toastify";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  filterByYear: Yup.string().required("Year of Appraisal is required"),
  pmsScore: Yup.string().nullable(),
});

const PmsScoreEnable = () => {
  const dispatch = useDispatch();
  const [showPmsScore, setShowPmsScore] = useState(false); // radio hidden initially
  const { getAllAppraisalYears } = useSelector(
    (state) => state?.getAllAppraisalYears
  );
  const { getAppraisalYearPmsScoreStatusByYear } = useSelector(
    (state) => state?.getAppraisalYearPmsScoreStatusByYear
  );

  console.log(getAppraisalYearPmsScoreStatusByYear,"getAppraisalYearPmsScoreStatusByYear")

  useEffect(() => {
    dispatch(setHeaderName("Reports"));
    dispatch(setSubHeaderName("PMS Score Enable"));

    // Fetch years list
    const data1 = { data: {}, method: "get", apiName: "getAllAppraisalYears" };
    dispatch(actions.GETALLAPPRAISALYEAR(data1));
  }, [dispatch]);

  const yearOptions = getAllAppraisalYears?.data?.map((data) => ({
    value: data?.appraisal_year_id,
    label: data?.appraisal_year,
  }));

  // When year changes → fetch PMS score for that year
  const handleYearChange = async (yearId, setFieldValue) => {
    if (!yearId) return;

    const data1 = {
      data: {},
      method: "get",
      apiName: `getAppraisalYearPmsScoreStatusByYear/${yearId}`, // or correct API that returns status
    };

    const responseData = await dispatch(actions.GETAPPRAISALYEARPMSSCORESTATUSBYYEAR(data1));
    console.log(responseData, "responseData on year change");

    if (
      responseData?.payload?.message === "No records found for pms this year."
    ) {
      toast.error("No records found for PMS this year.");
      setShowPmsScore(false);
      setFieldValue("pmsScore", ""); // reset
    } else if (responseData?.payload?.data) {
      setShowPmsScore(true);
      setFieldValue(
        "pmsScore",
        responseData?.payload?.data?.pms_score_status ? "true" : "false"
      );
    } else {
      setShowPmsScore(false);
      toast.error(responseData?.payload?.message || "Something went wrong");
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    const data1 = {
      data: {
        appraisal_year_id: values?.filterByYear,
        pms_score_show: values?.pmsScore === "true",
      },
      method: "put",
      apiName: "pmsScoreShowHide",
    };

    const responseData = await dispatch(actions.PMSSCORESHOWHIDE(data1));

    if (responseData?.payload?.message === "pms score showing updated .") {
      if (values?.pmsScore === "true") {
        toast.success("PMS score show enabled");
      } else {
        toast.success("PMS score show disabled");
      }
      resetForm();
      setShowPmsScore(false); // hide after submit
    } else {
      toast.error(responseData?.payload?.message || "Something went wrong");
    }
  };

  return (
    <Box sx={{ background: "white", p: 3 }}>
      <Typography
        variant="subtitle2"
        sx={{ color: "black", fontSize: "18px", mb: 2 }}
      >
        PMS Score Enable
      </Typography>
      <Formik
        initialValues={{ filterByYear: "", pmsScore: "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Grid container spacing={4}>
              <Grid item size={{ xs: 12, md: 6 }}>
                <CustomDropdownMui
                  name="filterByYear"
                  label="Select Year of Appraisal"
                  custPlaceholder="--Select Year of Appraisal--"
                  options={yearOptions}
                  value={values.filterByYear}
                  onChange={(val) => {
                    setFieldValue("filterByYear", val);
                    handleYearChange(val, setFieldValue);
                  }}
                />
              </Grid>

              {showPmsScore && (
                <Grid item xs={12} sm={5}>
                  <CustomRadioButton
                    name="pmsScore"
                    label="PMS Score"
                    value={values?.pmsScore}
                    onChange={(val) => setFieldValue("pmsScore", val)}
                    options={[
                      { label: "Enabled", value: "true" },
                      { label: "Disabled", value: "false" },
                    ]}
                  />
                </Grid>
              )}

              {showPmsScore && (
                <Grid item xs={12} sx={{ mt: 3 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      background: "var(--main-color)",
                      textTransform: "none",
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
              )}
            </Grid>
          </Form>
        )}
      </Formik>

      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </Box>
  );
};

export default PmsScoreEnable;
